import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/common/Section";
import Reveal from "@/components/common/Reveal";

export const CtaBand = ({
  title = "Ready to modernize your operations?",
  description = "See how Licara unifies permits, inspections, citations, and cases in one secure platform.",
  primaryLabel = "Request a demo",
  primaryTo = "/demo",
  secondaryLabel = "Talk to sales",
  secondaryTo = "/contact",
}) => {
  return (
    <section className="py-16 md:py-24">
      <Container>
        <Reveal>
          <div className="noise-overlay relative overflow-hidden rounded-[24px] border border-border bg-[hsl(220_30%_8%)] px-6 py-14 text-center md:px-16 md:py-20">
            <div className="hero-glow pointer-events-none absolute inset-0" />
            <div className="bg-sentira-grid bg-radial-fade pointer-events-none absolute inset-0 opacity-60" />
            <div className="relative">
              <h2 className="mx-auto max-w-2xl text-3xl font-semibold leading-tight tracking-[-0.02em] sm:text-4xl">
                {title}
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
                {description}
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Button
                  asChild
                  size="lg"
                  className="bg-primary text-primary-foreground shadow-[0_0_0_1px_rgba(20,184,166,0.25),0_10px_30px_rgba(20,184,166,0.12)] transition-transform hover:-translate-y-0.5 hover:bg-[hsl(173_80%_34%)]"
                >
                  <Link to={primaryTo} data-testid="cta-band-primary-button">
                    {primaryLabel}
                    <ArrowRight className="ml-1.5 h-4 w-4" />
                  </Link>
                </Button>
                <Button asChild size="lg" variant="secondary">
                  <Link to={secondaryTo} data-testid="cta-band-secondary-button">
                    {secondaryLabel}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default CtaBand;
